import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { DEPRECATED_backwardsCompatibleValues } from "@faire/web--source/common/localization/localize";
import { Button } from "@faire/web--source/slate/Button";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import * as React from "react";
export var getBestsellersCategoryHeaderText = function(highestPrecisionCategoryName, strictLocalize) {
    return strictLocalize({
        id: "8Ke2e2",
        defaultMessage: [
            {
                type: 0,
                value: "Bestsellers in "
            },
            {
                type: 1,
                value: "categoryCollectionName"
            }
        ]
    }, {
        categoryCollectionName: highestPrecisionCategoryName
    });
};
export var getSaleCategoryHeaderText = function(highestPrecisionCategoryName, strictLocalize) {
    return strictLocalize({
        id: "BjTyfr",
        defaultMessage: [
            {
                type: 0,
                value: "Sale "
            },
            {
                type: 1,
                value: "categoryCollectionName"
            }
        ]
    }, {
        categoryCollectionName: highestPrecisionCategoryName.toLowerCase()
    });
};
export var getEcoFriendlyCategoryHeaderText = function(ecoFriendlyCategoryDisplayName, parentCategoryName) {
    if (parentCategoryName === undefined) {
        return ecoFriendlyCategoryDisplayName;
    }
    return parentCategoryName + " | " + ecoFriendlyCategoryDisplayName;
};
export var getShowroomCategoryHeaderText = function(showroomCategoryDisplayName, parentCategoryName) {
    if (parentCategoryName === undefined) {
        return showroomCategoryDisplayName;
    }
    return parentCategoryName + " | " + showroomCategoryDisplayName;
};
export var getNewBrandsCategorySubheaderText = function(highestPrecisionCategory, strictLocalize) {
    return strictLocalize({
        id: "kTei71",
        defaultMessage: [
            {
                type: 0,
                value: "Shop our newest brands in "
            },
            {
                type: 1,
                value: "highestPrecisionCategory"
            }
        ]
    }, DEPRECATED_backwardsCompatibleValues({
        highestPrecisionCategory: highestPrecisionCategory
    }));
};
export var getNewProductsCategorySubheaderText = function(highestPrecisionCategory, strictLocalize) {
    return strictLocalize({
        id: "Uobxgg",
        defaultMessage: [
            {
                type: 0,
                value: "Shop our fresh new finds in "
            },
            {
                type: 1,
                value: "highestPrecisionCategory"
            }
        ]
    }, DEPRECATED_backwardsCompatibleValues({
        highestPrecisionCategory: highestPrecisionCategory
    }));
};
export var getInsiderEarlyAccessSubheaderText = function(isNonAmericanInsider, helpCenterLink) {
    if (isNonAmericanInsider) {
        return /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "4YQvgH",
            defaultMessage: [
                {
                    type: 0,
                    value: "Discover the newest brands on Faire 48 hours before the rest of the marketplace."
                }
            ]
        });
    } else {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(Spacer, {
                    size: "1x"
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "tndgnh",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Shop the newest brands to join Faire. "
                            },
                            {
                                type: 8,
                                value: "LinkFormatting",
                                children: [
                                    {
                                        type: 0,
                                        value: "Learn More"
                                    }
                                ]
                            }
                        ],
                        values: {
                            LinkFormatting: function(chunk) {
                                return LinkFormmatting(chunk, helpCenterLink);
                            }
                        }
                    })
                })
            ]
        });
    }
};
var LinkFormmatting = function(chunk, helpCenterLink) {
    return /*#__PURE__*/ _jsx(Button, {
        variant: "tertiary",
        linkTo: helpCenterLink,
        target: "_blank",
        children: chunk
    });
};
